module.exports = __webpack_public_path__ + "img/born.c2fb1ab7.svg";